export enum ServiceNames {
    OFFER_SERVICE = 'offerService',
    HOTEL_OFFER_SERVICE = 'hotelOfferService',
    HOTEL_SERVICE = 'hotelService',
    OFFER_INFO_SERVICE = 'offerInfoService',
}
